<div class="quiz-page">
  <div class="quiz-container">
    <div class="left-pane">
      <h3>
        <i class="bi bi-cloud-arrow-up me-2"></i>
        Upload Questions via PDF/DOCX
      </h3>

      <button class="btn-outline mt-2" (click)="downloadPDFTemplate()">
        <i class="bi bi-download me-2"></i>
        Download PDF
      </button>

      <button class="btn-outline ms-3 mt-2" (click)="downloadDOCXTemplate()">
        <i class="bi bi-download me-2"></i>
        Download Docx
      </button>

      <div class="upload-box" (click)="!isLoading && pdfInput.click()">
        <input
          type="file"
          #pdfInput
          hidden
          accept=".pdf,.doc,.docx"
          (change)="onPDFSelected($event)"
        />

        <div class="upload-icon" *ngIf="!fileName">
          <i class="bi bi-upload"></i>
        </div>

        <p>
          Drop a PDF or DOCX file, or click to
          <span class="link">browse</span>
        </p>

        <small> Supported : PDF, DOCX Max size: 50 MB </small>
      </div>

      <div class="document-format-card" *ngIf="!fileName && !showUploadResult">
        <div class="format-header">
          <i class="bi bi-journal-text"></i>
          <h4>Required Document Format</h4>
        </div>

        <div class="example-box">
          <div class="example-title">Example block</div>

          <pre>
              SUB CONCEPT NAME : Rate of Change of Quantities
              DIFFICULTY LEVEL : Easy

              1. A particle moves along the curve y = x^(3/2).If its distance from 
              the origin increases at 11 units/sec, find dx/dt when x = 3.

              (A) 4
              (B) 9/2
              (C) 3*sqrt(3) / 2
              (D) 12

              Ans.: 4
          </pre>
        </div>

        <div class="format-rules">
          <div class="rule-item">
            <i class="bi bi-check-circle-fill"></i>
            <div>
              <h5>SUB CONCEPT NAME</h5>
              <p>Header line, groups questions by subtopic</p>
            </div>
          </div>

          <div class="rule-item">
            <i class="bi bi-check-circle-fill"></i>
            <div>
              <h5>DIFFICULTY LEVEL</h5>
              <p>Easy / Medium / Hard</p>
            </div>
          </div>

          <div class="rule-item">
            <i class="bi bi-check-circle-fill"></i>
            <div>
              <h5>Question</h5>
              <p>Numbered (1., 2., …) — LaTeX supported with $...$</p>
            </div>
          </div>

          <div class="rule-item">
            <i class="bi bi-check-circle-fill"></i>
            <div>
              <h5>Options</h5>
              <p>(A) – (D), minimum 2 per question</p>
            </div>
          </div>

          <div class="rule-item">
            <i class="bi bi-check-circle-fill"></i>
            <div>
              <h5>Answer</h5>
              <p>Line starting with 'Ans.:' matching one option</p>
            </div>
          </div>

          <div class="rule-item">
            <i class="bi bi-check-circle-fill"></i>
            <div>
              <h5>Diagrams</h5>
              <p>Embedded PNG/JPEG auto-extracted</p>
            </div>
          </div>
        </div>

        <div class="format-footer">
          Diagrams embedded in the document are auto-extracted and shown next to
          the question.
        </div>
      </div>

      <div *ngIf="fileName" class="file-card">
        <div class="file-left">
          <i class="bi bi-file-earmark-pdf file-icon"></i>

          <div class="file-info">
            <span class="file-name">{{ fileName }}</span>

            <span class="file-size" *ngIf="selectedFile">
              {{ (selectedFile.size / 1024).toFixed(1) }} KB
            </span>
          </div>
        </div>

        <button
          class="remove-btn"
          (click)="removeFile($event)"
          [disabled]="isLoading"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="processing-box" *ngIf="isLoading">
        <div class="processing-top">
          <mat-spinner diameter="28"></mat-spinner>

          <div class="processing-content">
            <h4>Extracting Questions from File</h4>

            <p>Please wait while we process your document.</p>

            <span class="question-count">
              {{ questionExtracted || 0 }}
              Questions Extracted
            </span>
          </div>
        </div>
      </div>
      <div class="result-wrapper" *ngIf="showUploadResult && !isLoading">
        <!-- STATS -->
        <div class="stats-grid">
          <div class="result-card blue">
            <div class="result-icon blue">
              <i class="bi bi-files"></i>
            </div>

            <div class="result-info">
              <h2>{{ totalPages }}</h2>
              <span>Total Pages</span>
            </div>
          </div>

          <div class="result-card green">
            <div class="result-icon green">
              <i class="bi bi-check-circle"></i>
            </div>

            <div class="result-info">
              <h2>{{ questionExtracted }}</h2>
              <span>Questions Extracted</span>
            </div>
          </div>

          <div class="result-card red">
            <div class="result-icon red">
              <i class="bi bi-x-circle"></i>
            </div>

            <div class="result-info">
              <h2>{{ questionFailedCount }}</h2>
              <span>Failed</span>
            </div>
          </div>
        </div>

        <!-- SUCCESS -->
        <div class="success-box" *ngIf="questionExtracted > 0">
          <div class="success-left">
            <i class="bi bi-check-circle-fill"></i>

            <span>
              {{ questionExtracted }}
              questions extracted with Chapter, Topic and Subtopic tags applied.
            </span>
          </div>
        </div>

        <!-- FAILED -->
        <div class="failed-box" *ngIf="questionFailedCount > 0">
          <div class="failed-header">
            <i class="bi bi-exclamation-triangle"></i>

            <span>
              {{ questionFailedCount }}
              questions couldn't be extracted
            </span>
          </div>

          <div class="failed-item" *ngFor="let item of failedQuestionDetails">
            <div class="failed-badge">Q{{ item.question_number }}</div>

            <div class="failed-content">
              <h5>{{ item.page }}</h5>
              <p class="preview-text">
                {{ item.question_text_preview }}
              </p>

              <div
                class="reason-item"
                *ngFor="let reason of item.failure_reasons"
              >
                <i class="bi bi-dot"></i>
                {{ reason }}
              </div>
            </div>
          </div>
        </div>
        <!--  -->
      </div>
    </div>
    <div class="right-pane">
      <app-question-preview
        [isPreviewVisible]="showPreview"
      ></app-question-preview>
    </div>
  </div>
</div>
